export default __webpack_public_path__ + "static/media/books2-afterB-1024w.cfe8dbb5.webp";